/**
 * useCflCampaign Hook
 *
 * Fetches and manages CFL (Crypto Fantasy League) campaign status.
 * Returns campaign details including:
 * - Whether campaign is active
 * - User's bonus points earned
 * - Remaining bonus available
 * - Campaign dates
 * - Whether user is in the CFL whitelist
 */

import { useQuery } from '@tanstack/react-query';

import { getCflCampaignStatus } from '@/api/auth';

export function useCflCampaign() {
  const query = useQuery({
    queryKey: ['cflCampaign'],
    queryFn: async () => {
      const response = await getCflCampaignStatus();
      if (response.code !== 0) {
        throw new Error(response.message || 'Failed to fetch campaign status');
      }
      return response.data;
    },
    staleTime: 30 * 1000, // Cache for 30 seconds
    refetchInterval: 60 * 1000, // Refetch every 60 seconds to keep countdown updated
  });

  return {
    campaignData: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
